"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.literaki = void 0;
const constants_1 = require("@scrabble-solver/constants");
const types_1 = require("@scrabble-solver/types");
exports.literaki = {
    bingo: { score: 50 },
    blankScore: 0,
    blanksCount: 2,
    boardHeight: 15,
    boardWidth: 15,
    game: types_1.Game.Literaki,
    name: 'Literaki',
    rackSize: 7,
    bonuses: [
        { multiplier: 3, score: 5, type: constants_1.BONUS_CHARACTER, x: 0, y: 0 },
        { multiplier: 3, type: constants_1.BONUS_WORD, x: 2, y: 0 },
        { multiplier: 3, score: 2, type: constants_1.BONUS_CHARACTER, x: 5, y: 0 },
        { multiplier: 3, score: 5, type: constants_1.BONUS_CHARACTER, x: 7, y: 0 },
        { multiplier: 3, score: 2, type: constants_1.BONUS_CHARACTER, x: 9, y: 0 },
        { multiplier: 3, type: constants_1.BONUS_WORD, x: 12, y: 0 },
        { multiplier: 3, score: 5, type: constants_1.BONUS_CHARACTER, x: 14, y: 0 },
        { multiplier: 3, score: 2, type: constants_1.BONUS_CHARACTER, x: 4, y: 1 },
        { multiplier: 3, score: 5, type: constants_1.BONUS_CHARACTER, x: 6, y: 1 },
        { multiplier: 3, score: 5, type: constants_1.BONUS_CHARACTER, x: 8, y: 1 },
        { multiplier: 3, score: 2, type: constants_1.BONUS_CHARACTER, x: 10, y: 1 },
        { multiplier: 3, type: constants_1.BONUS_WORD, x: 0, y: 2 },
        { multiplier: 3, score: 2, type: constants_1.BONUS_CHARACTER, x: 3, y: 2 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 5, y: 2 },
        { multiplier: 3, score: 1, type: constants_1.BONUS_CHARACTER, x: 7, y: 2 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 9, y: 2 },
        { multiplier: 3, score: 2, type: constants_1.BONUS_CHARACTER, x: 11, y: 2 },
        { multiplier: 3, type: constants_1.BONUS_WORD, x: 14, y: 2 },
        { multiplier: 3, score: 2, type: constants_1.BONUS_CHARACTER, x: 2, y: 3 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 4, y: 3 },
        { multiplier: 3, score: 1, type: constants_1.BONUS_CHARACTER, x: 6, y: 3 },
        { multiplier: 3, score: 1, type: constants_1.BONUS_CHARACTER, x: 8, y: 3 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 10, y: 3 },
        { multiplier: 3, score: 2, type: constants_1.BONUS_CHARACTER, x: 12, y: 3 },
        { multiplier: 3, score: 2, type: constants_1.BONUS_CHARACTER, x: 1, y: 4 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 3, y: 4 },
        { multiplier: 3, score: 1, type: constants_1.BONUS_CHARACTER, x: 5, y: 4 },
        { multiplier: 3, score: 1, type: constants_1.BONUS_CHARACTER, x: 9, y: 4 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 11, y: 4 },
        { multiplier: 3, score: 2, type: constants_1.BONUS_CHARACTER, x: 13, y: 4 },
        { multiplier: 3, score: 2, type: constants_1.BONUS_CHARACTER, x: 0, y: 5 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 2, y: 5 },
        { multiplier: 3, score: 1, type: constants_1.BONUS_CHARACTER, x: 4, y: 5 },
        { multiplier: 3, score: 3, type: constants_1.BONUS_CHARACTER, x: 7, y: 5 },
        { multiplier: 3, score: 1, type: constants_1.BONUS_CHARACTER, x: 10, y: 5 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 12, y: 5 },
        { multiplier: 3, score: 2, type: constants_1.BONUS_CHARACTER, x: 14, y: 5 },
        { multiplier: 3, score: 5, type: constants_1.BONUS_CHARACTER, x: 1, y: 6 },
        { multiplier: 3, score: 1, type: constants_1.BONUS_CHARACTER, x: 3, y: 6 },
        { multiplier: 3, score: 3, type: constants_1.BONUS_CHARACTER, x: 6, y: 6 },
        { multiplier: 3, score: 3, type: constants_1.BONUS_CHARACTER, x: 8, y: 6 },
        { multiplier: 3, score: 1, type: constants_1.BONUS_CHARACTER, x: 11, y: 6 },
        { multiplier: 3, score: 5, type: constants_1.BONUS_CHARACTER, x: 13, y: 6 },
        { multiplier: 3, score: 5, type: constants_1.BONUS_CHARACTER, x: 0, y: 7 },
        { multiplier: 3, score: 1, type: constants_1.BONUS_CHARACTER, x: 2, y: 7 },
        { multiplier: 3, score: 3, type: constants_1.BONUS_CHARACTER, x: 5, y: 7 },
        { multiplier: 3, score: 5, type: constants_1.BONUS_CHARACTER, x: 7, y: 7 },
        { multiplier: 3, score: 3, type: constants_1.BONUS_CHARACTER, x: 9, y: 7 },
        { multiplier: 3, score: 1, type: constants_1.BONUS_CHARACTER, x: 12, y: 7 },
        { multiplier: 3, score: 5, type: constants_1.BONUS_CHARACTER, x: 14, y: 7 },
        { multiplier: 3, score: 5, type: constants_1.BONUS_CHARACTER, x: 1, y: 8 },
        { multiplier: 3, score: 1, type: constants_1.BONUS_CHARACTER, x: 3, y: 8 },
        { multiplier: 3, score: 3, type: constants_1.BONUS_CHARACTER, x: 6, y: 8 },
        { multiplier: 3, score: 3, type: constants_1.BONUS_CHARACTER, x: 8, y: 8 },
        { multiplier: 3, score: 1, type: constants_1.BONUS_CHARACTER, x: 11, y: 8 },
        { multiplier: 3, score: 5, type: constants_1.BONUS_CHARACTER, x: 13, y: 8 },
        { multiplier: 3, score: 2, type: constants_1.BONUS_CHARACTER, x: 0, y: 9 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 2, y: 9 },
        { multiplier: 3, score: 1, type: constants_1.BONUS_CHARACTER, x: 4, y: 9 },
        { multiplier: 3, score: 3, type: constants_1.BONUS_CHARACTER, x: 7, y: 9 },
        { multiplier: 3, score: 1, type: constants_1.BONUS_CHARACTER, x: 10, y: 9 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 12, y: 9 },
        { multiplier: 3, score: 2, type: constants_1.BONUS_CHARACTER, x: 14, y: 9 },
        { multiplier: 3, score: 2, type: constants_1.BONUS_CHARACTER, x: 1, y: 10 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 3, y: 10 },
        { multiplier: 3, score: 1, type: constants_1.BONUS_CHARACTER, x: 5, y: 10 },
        { multiplier: 3, score: 1, type: constants_1.BONUS_CHARACTER, x: 9, y: 10 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 11, y: 10 },
        { multiplier: 3, score: 2, type: constants_1.BONUS_CHARACTER, x: 13, y: 10 },
        { multiplier: 3, score: 2, type: constants_1.BONUS_CHARACTER, x: 2, y: 11 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 4, y: 11 },
        { multiplier: 3, score: 1, type: constants_1.BONUS_CHARACTER, x: 6, y: 11 },
        { multiplier: 3, score: 1, type: constants_1.BONUS_CHARACTER, x: 8, y: 11 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 10, y: 11 },
        { multiplier: 3, score: 2, type: constants_1.BONUS_CHARACTER, x: 12, y: 11 },
        { multiplier: 3, type: constants_1.BONUS_WORD, x: 0, y: 12 },
        { multiplier: 3, score: 2, type: constants_1.BONUS_CHARACTER, x: 3, y: 12 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 5, y: 12 },
        { multiplier: 3, score: 1, type: constants_1.BONUS_CHARACTER, x: 7, y: 12 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 9, y: 12 },
        { multiplier: 3, score: 2, type: constants_1.BONUS_CHARACTER, x: 11, y: 12 },
        { multiplier: 3, type: constants_1.BONUS_WORD, x: 14, y: 12 },
        { multiplier: 3, score: 2, type: constants_1.BONUS_CHARACTER, x: 4, y: 13 },
        { multiplier: 3, score: 5, type: constants_1.BONUS_CHARACTER, x: 6, y: 13 },
        { multiplier: 3, score: 5, type: constants_1.BONUS_CHARACTER, x: 8, y: 13 },
        { multiplier: 3, score: 2, type: constants_1.BONUS_CHARACTER, x: 10, y: 13 },
        { multiplier: 3, score: 5, type: constants_1.BONUS_CHARACTER, x: 0, y: 14 },
        { multiplier: 3, type: constants_1.BONUS_WORD, x: 2, y: 14 },
        { multiplier: 3, score: 2, type: constants_1.BONUS_CHARACTER, x: 5, y: 14 },
        { multiplier: 3, score: 5, type: constants_1.BONUS_CHARACTER, x: 7, y: 14 },
        { multiplier: 3, score: 2, type: constants_1.BONUS_CHARACTER, x: 9, y: 14 },
        { multiplier: 3, type: constants_1.BONUS_WORD, x: 12, y: 14 },
        { multiplier: 3, score: 5, type: constants_1.BONUS_CHARACTER, x: 14, y: 14 },
    ],
};
